/** @format */

import { FiPlus } from 'react-icons/fi';
import Question from './Question';
import { useAuthStore } from '../../context/useAuthStore';

interface SubjectHeaderProps {
	subject?: string;
	onAddCustomQuestion: () => void;
	onSubjectChange: (subjectId: string) => void;
	subjectOptions: { subjectName: string; subjectCode: string }[];
	selectedSubjectId: string | null;
	onBareActClick: () => void;
	onExportPdfClick: () => void;
}

const SubjectHeader: React.FC<SubjectHeaderProps> = ({
	subject,
	onAddCustomQuestion,
	onSubjectChange,
	subjectOptions,
	selectedSubjectId,
	onBareActClick,
	onExportPdfClick,
}) => {
	const { user } = useAuthStore();
	const PRODUCT_TEAM_ID = String(import.meta.env.VITE_PRODUCT_TEAM_ID).trim();

	return (
		<div className='subjectHeader'>
			<Question
				onSubjectChange={onSubjectChange}
				subjectOptions={subjectOptions}
				selectedSubject={selectedSubjectId}
			/>
			<div className='relative group flex gap-2'>
				<button
					onClick={onAddCustomQuestion}
					className='customQuestionBtn'
					disabled={!subject}>
					<FiPlus size={20} />{' '}
					<span className='sm:flex hidden'>Add custom question</span>{' '}
					<span className='flex sm:hidden w-12 capitalize'>
						custom question
					</span>
				</button>
				<button
					onClick={onBareActClick}
					className='customQuestionBtn py-2'
					disabled={!subject}>
					Bare Act
				</button>
				{user?.roleId === PRODUCT_TEAM_ID && (
					<button
						onClick={onExportPdfClick}
						className='customQuestionBtn py-2'
						disabled={!subject}>
						Export PDF
					</button>
				)}

				{!subject && (
					<div className='absolute top-12 left-1/2 w-full -translate-x-1/2 bg-gray-800 text-white text-xs p-2 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10'>
						Please select a subject to add custom question!
					</div>
				)}
			</div>
		</div>
	);
};

export default SubjectHeader;
